import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import {
  DESKTOP_MIN_WIDTH,
  EDIT_RECEIVER_BANK_EWALLET_NAME,
  METHOD_BANK,
  METHOD_EWALLET,
} from 'constants';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputBankEwalletRadio = ({
  deliveryMethods,
  banksLength,
  ewalletsLength,
  isBanksChecked,
  setBanksChecked,
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();

  const formCheckRadioClassName1 = EDIT_RECEIVER_BANK_EWALLET_NAME + '1';
  const formCheckRadioClassName2 = EDIT_RECEIVER_BANK_EWALLET_NAME + '2';

  const handleOnChange = (value) => {
    setBanksChecked(value);
  };

  const renderFormCheckRadio1 = () => {
    if (!deliveryMethods?.includes(METHOD_BANK)) return null;
    return (
      <FormCheckboxRadio
        name={EDIT_RECEIVER_BANK_EWALLET_NAME}
        className={`${formCheckRadioClassName1} ${isBanksChecked && 'active'}`}
        label={`${t('label_bank_account')} (${banksLength})`}
        isChecked={isBanksChecked}
        onClick={() => handleOnChange(true)}
        styles={{ marginRight: '16px' }}
      />
    );
  };

  const renderFormCheckRadio2 = () => {
    if (!deliveryMethods?.includes(METHOD_EWALLET)) return null;
    return (
      <FormCheckboxRadio
        name={EDIT_RECEIVER_BANK_EWALLET_NAME}
        className={`${formCheckRadioClassName2} ${!isBanksChecked && 'active'}`}
        label={`${t('label_ewallet')} (${ewalletsLength})`}
        isChecked={!isBanksChecked}
        onClick={() => handleOnChange(false)}
        styles={{ marginRight: 0 }}
      />
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel onClick={(e) => e.preventDefault()}>
        {t('label_account_type')}
      </FormLabel>
      <FormCheckWrapper>
        {renderFormCheckRadio1()}
        {renderFormCheckRadio2()}
      </FormCheckWrapper>
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 24px;
  }
`;
const FormLabel = styled(Form.Label)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  display: block;
  color: var(--ds-c-grey-dark);
  margin-bottom: 16px;

  span {
    color: var(--c-required);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 24px;
  }
`;
const FormCheckWrapper = styled.div`
  display: flex;
`;

export default FormInputBankEwalletRadio;
